import { Pipe, PipeTransform } from '@angular/core';
import { EnvironmentService } from '../services/environment.service'
import { CurrencyFormatter } from '../utils/currency-formatter';

@Pipe({
    name: 'formatCurrency',
    standalone: false
})
export class FormatCurrencyPipe implements PipeTransform {

  constructor(public _environmentService: EnvironmentService) {
  }
  /**
   *
   * @param value
   * @param {number} digitsToTrim
   * @param {string} unitType
   * @param {number} decimalPlaces
   * @returns {any}
   */
  transform(value: any, digitsToTrim: number = 0, unitType: string = null, decimalPlaces: number = null): any {

    const pattern: string = this._environmentService.getCurrencyFormat();

    return CurrencyFormatter.format(value, pattern, digitsToTrim, unitType, decimalPlaces)
  }
}

